import React from "react";
import { EditIconDarkGray, TrashIconGray } from "../../constant/imagePath";
import Colors from "../assets/Colors";
import { Button } from "../Button/Button";
import classes from "./UploadedImageWithEditAndDelete.module.css";

export function UploadedImageWithEditAndDelete({
  editClick,
  deleteClick,
  image,
}) {
  return (
    <div className="d-flex">
      <div className={classes.imageUpdated}>
        <img
          src={typeof image === "object" ? URL.createObjectURL(image) : image}
        />
      </div>
      {/* Image Controls */}
      <div className={classes.imageControls}>
        <Button
          icon={EditIconDarkGray}
          onClick={editClick}
          primary={false}
          customStyle={{
            border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
            marginBottom: "10px",
          }}
        />
        <Button
          icon={TrashIconGray}
          onClick={deleteClick}
          primary={false}
          customStyle={{
            border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
          }}
        />
      </div>
    </div>
  );
}
